import { Box, Card, Grid, LoadingOverlay, Text } from '@mantine/core';
import PropTypes from 'prop-types';
import React from 'react';
import BadgeStatus from '../../elements/BadgeStatus';
import GridCell from '../../elements/GridCell';

function DetailLogMerchant({ data, loading }){
  return (
    <Box pos="relative">
      <LoadingOverlay overlayProps={{ radius: 'sm', blur: 2 }} visible={loading} zIndex={99} />
      <Card mb={24} radius="md" withBorder>
        <Card.Section inheritPadding py="xs" withBorder>
          <Text fw={700}>{data.storeName}</Text>
          <Text color="dimmed" size="sm">ID Pangkalan: {data.registrationId}</Text>
        </Card.Section>
        <Card.Section inheritPadding py="xs">
          <Text fw={700}>Data Pangkalan LPG 3 Kg</Text>
          <Grid>
            <Grid.Col lg={6} md={1}>
              <GridCell data={data.date} label="Tanggal" left={4} right={7} />
              <GridCell data={data.time} label="Jam" left={4} right={7}/>
              <GridCell data={data.agen} label="ID Agen" left={4} right={7}/>
              <GridCell data={data.midMap} label="MID" left={4} right={7}/>
            </Grid.Col>
            <Grid.Col lg={5} md={1}>
              <GridCell data={data.phoneNumber} label="No. Ponsel Pemilik" left={4} right={7}/>
              <GridCell data={data.email} label="Email Pemilik" left={4} right={7}/>
            </Grid.Col>
          </Grid>
        </Card.Section>
      </Card>
      <Card mb={24} radius="md" withBorder>
        <Card.Section inheritPadding py="lg">
          <Grid>
            <Grid.Col lg={2} md={1}>
              <Text color="dimmed">Status</Text>
              <BadgeStatus label={data.status} />
            </Grid.Col>
            <Grid.Col lg={7} md={1} style={{ borderLeft: '1px solid #D9DEE4', marginLeft: '0.5rem' }}>
              <Text color="dimmed">Alasan</Text>
              <ul>
                {data.reasons.map((reason) => (
                  <li key={reason}><Text color="dimmed">{reason}</Text></li>
                ))}
              </ul>
            </Grid.Col>
          </Grid>
        </Card.Section>
      </Card>
    </Box>
  );
}

DetailLogMerchant.propTypes = {
  data: PropTypes.shape({
    registrationId: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
    storeName: PropTypes.string,
    agen: PropTypes.string,
    phoneNumber: PropTypes.string,
    email: PropTypes.string,
    midMap: PropTypes.string,
    reasons: PropTypes.array,
    status: PropTypes.string
  }).isRequired,
  loading: PropTypes.bool,
};

export default DetailLogMerchant;
